module.exports = __webpack_public_path__ + "static/img/temperature.05e55456.svg";